import { Link } from "react-router-dom";
import { Logo, scrollToId } from "@/components/Logo";
import { WhatsAppIcon, WHATSAPP_URL } from "@/components/WhatsApp";

export const Footer = () => (
  <footer className="border-t border-industrial-700 bg-industrial-900/60" data-testid="main-footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-14">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-10">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <Logo className="w-14 h-14 -my-2" />
            <span className="font-display font-black text-2xl sm:text-3xl tracking-wider uppercase">
              Piezas Aljarafe <span className="text-brand-orange">24H</span>
            </span>
          </div>
          <p className="text-slate-500 text-sm max-w-sm">
            Tu pides la pieza, nosotros la buscamos por ti. Recambios verificados con envío express en toda España.
          </p>
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-whatsapp-link"
            className="mt-5 inline-flex items-center gap-2.5 border border-[#25D366]/50 text-[#25D366] hover:bg-[#25D366]/10 font-mono text-xs uppercase tracking-widest px-5 py-3 rounded-sm transition-colors"
          >
            <WhatsAppIcon className="w-4 h-4" /> 644 856 072
          </a>
        </div>
        <div className="flex flex-wrap gap-x-10 gap-y-4">
          {[
            { label: "Cómo funciona", target: "#como-funciona" },
            { label: "Presupuesto", target: "#presupuesto" },
            { label: "Ventajas", target: "#ventajas" },
            { label: "Preguntas", target: "#faq" },
          ].map((l) => (
            <button
              key={l.target}
              onClick={() => scrollToId(l.target)}
              data-testid={`footer-link-${l.target.slice(1)}`}
              className="font-mono text-xs uppercase tracking-widest text-slate-400 hover:text-brand-amber transition-colors"
            >
              {l.label}
            </button>
          ))}
          <Link to="/admin" data-testid="footer-admin-link" className="font-mono text-xs uppercase tracking-widest text-slate-600 hover:text-slate-300 transition-colors">
            Acceso taller
          </Link>
        </div>
      </div>
      <div className="mt-12 pt-6 border-t border-industrial-700/60 flex flex-col sm:flex-row justify-between gap-3">
        <p className="font-mono text-[10px] uppercase tracking-widest text-slate-600">Piezas Aljarafe 24H © 2026 · Todos los derechos reservados</p>
        <p className="font-mono text-[10px] uppercase tracking-widest text-slate-600">Respuesta media &lt; 2h · Servicio 24H</p>
      </div>
    </div>
  </footer>
);
